export default __webpack_public_path__ + "img/product-arrow-right.dc63647a.svg";